import { apiErrorResponse, apiSuccessResponse } from '../constants'
import { ApiResponse } from '../types'

export default async function adapter<T>({
  response,
  json,
}: {
  response: Response
  json: any
}): Promise<ApiResponse<T> | null> {
  const message = json?.message
  const token = json?.token
  const result = json?.data || token || message
  const status = json?.status

  if (typeof status === 'number' && status > 0 && !!status) {
    return apiSuccessResponse({
      ok: true,
      status,
      result,
      response,
    })
  }
  if (message) {
    return apiErrorResponse({
      status,
      message,
    })
  }
  return null
}
